import * as React from "react";

import Header from "@/Components/Headers/Components/Header";

type Props = {
  title: string;
};

function SettingsHeader({ title }: Props): React.JSX.Element {
  return (
    <Header
      tabs={[{ title: title, isActive: true, onPress: (): void => {} }]}
      showDrawerButton={true}
    />
  );
}

export default SettingsHeader;
